import { IBar, IScoreEditorThis } from "../../../../../common/types";
import { handleSolfaInput } from "../pitch";
import { handleDotInput } from "./handleDotInput";
import { handleRemoveNote } from "./handleRemoveNote";
import { handleRhythmInput } from "./handleRhythmInput";
import { handleSelect } from "./handleSelect";
import { handleToggleRest } from "./handleToggleRest";

const keys = {
  ti: "KeyJ",
  ta: "KeyK",
  taa: "KeyU",
  taaaa: "KeyI",
  ri: "KeyM",
  dot: "KeyL",
  rest: "KeyO",
  backspace: "Backspace",
  soL: "KeyZ",
  laL: "KeyX",
  tiL: "KeyC",
  do: "KeyA",
  re: "KeyS",
  mi: "KeyD",
  fa: "KeyF",
  so: "KeyQ",
  la: "KeyW",
  tiSolfa: "KeyE",
  doU: "KeyR",
  reU: "Digit1",
  miU: "Digit2",
  faU: "Digit3",
  soU: "Digit4",
};

export function keydown(this: IScoreEditorThis, e: KeyboardEvent) {
  const { selectedNote, score, activeVoice, playing } = this.state;
  if (!score || playing) return;
  if ((document.activeElement as Element).tagName === "INPUT") return;
  if ((document.activeElement as Element).tagName === "TEXTAREA") return;
  if (e.metaKey || e.ctrlKey) return;
  const { taskType } = this.props;
  const intervalsTask = taskType === "intervals" || taskType === "chords3";
  const rhytNotationTask = taskType === "rhytNotation";
  const bars = score["bars" + (activeVoice || "")] as IBar[];
  if (e.code === keys.ti && !intervalsTask) {
      e.preventDefault();
      handleRhythmInput.call(this, 8, e);
  }
  if (e.code === keys.ta && !intervalsTask) {
      e.preventDefault();
      handleRhythmInput.call(this, 4, e);
  }
  if (e.code === keys.taa && !intervalsTask) {
      e.preventDefault();
      handleRhythmInput.call(this, 2, e);
  }
  if (e.code === keys.taaaa) {
      e.preventDefault();
      handleRhythmInput.call(this, 1, e);
  }
  if (e.code === keys.ri && !intervalsTask) {
      e.preventDefault();
      handleRhythmInput.call(this, 16, e);
  }
  if (e.code === keys.dot && !intervalsTask) {
      e.preventDefault();
      handleDotInput.call(this, e);
  }
  if (e.code === keys.rest && !intervalsTask) {
      e.preventDefault();
      handleToggleRest.call(this, e);
  }
  if (e.code === keys.backspace) {
      e.preventDefault();
      handleRemoveNote.call(this, e);
  }
  if (e.code === keys.soL && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 2, o: -1 }, null, false, e);
  }
  if (e.code === keys.laL && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 4, o: -1 }, null, false, e);
  }
  if (e.code === keys.tiL && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 6, o: -1 }, null, false, e);
  }
  if (e.code === keys.do && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 1, o: 0 }, null, false, e);
  }
  if (e.code === keys.re && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 3, o: 0 }, null, false, e);
  }
  if (e.code === keys.mi && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 5, o: 0 }, null, false, e);
  }
  if (e.code === keys.fa && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 0, o: 0 }, null, false, e);
  }
  if (e.code === keys.so && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 2, o: 0 }, null, false, e);
  }
  if (e.code === keys.la && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 4, o: 0 }, null, false, e);
  }
  if (e.code === keys.tiSolfa && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 6, o: 0 }, null, false, e);
  }
  if (e.code === keys.doU && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 1, o: 1 }, null, false, e);
  }
  if (e.code === keys.reU && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 3, o: 1 }, null, false, e);
  }
  if (e.code === keys.miU && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 5, o: 1 }, null, false, e);
  }
  if (e.code === keys.faU && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 0, o: 1 }, null, false, e);
  }
  if (e.code === keys.soU && !rhytNotationTask) {
      e.preventDefault();
      handleSolfaInput.call(this, { s: 2, o: 1 }, null, false, e);
  }
  if (e.code === "ArrowLeft") {
      e.preventDefault();
      let bar, note;
      if (selectedNote) {
          bar = selectedNote.bar;
          note = selectedNote.note - 1;
          if (note === -1) {
              bar--;
              if (bar === -1) return;
              if (bar === 0 && !score.bars[0]) return;
              note = bars[bar].notes.length - 1;
          }
      } else {
          bar = bars.length - 1;
          if (!bars[bar].notes.length) {
              bar--;
          }
          if (!bar || !bars[bar].notes) {
              return;
          }
          if (bars[bar].notes.length === 0) return;
          note = bars[bar].notes.length - 1;
      }
      handleSelect.call(this, bar, note, activeVoice);
      return;
  } else if (e.code === "ArrowRight") {
      e.preventDefault();
      let bar, note;
      if (selectedNote) {
          bar = selectedNote.bar;
          note = selectedNote.note + 1;
          if (note === bars[bar].notes.length) {
              bar++;
              if (!bars[bar]) return this.setState({ selectedNote: null });
              note = 0;
          }
          if (!bars[bar].notes[note]) return this.setState({ selectedNote: null });
          handleSelect.call(this, bar, note, activeVoice);
      }
      return;
  }
  if (!selectedNote) return;
  const note = bars[selectedNote.bar]?.notes[selectedNote.note];
  if (!note) return;
  const { p, r } = note;
  if (r || !p) return;
  if (e.code === "ArrowUp") {
      e.preventDefault();
      handleSolfaInput.call(this, null, 1, false, e);
  } else if (e.code === "ArrowDown") {
      e.preventDefault();
      handleSolfaInput.call(this, null, -1, false, e);
  }
};
